import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const issueDestinationAPI = {
    // Issue Destinations CRUD
    create: async (destinationData) => {
        try {
            const { data } = await api.post('/api/issue-destinations/create/', destinationData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create issue destination error:');
        }
    },
    
    getAll: async (params = {}) => {
        try {
            const { data } = await api.get('/api/issue-destinations/', { params });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all issue destinations error:');
        }
    },
    
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/issue-destinations/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get issue destination by id error:');
        }
    },
    
    update: async (id, destinationData) => {
        try {
            const { data } = await api.put(`/api/issue-destinations/update/${id}/`, destinationData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update issue destination error:');
        }
    },
    
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/issue-destinations/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete issue destination error:');
        }
    },
    
    getOptions: async () => {
        try {
            const { data } = await api.get('/api/issue-destinations/options/');
            return data;
        } catch (error) {
            handleApiError(error, 'Get issue destination options error:');
        }
    },
    
    
    // Issue Destination Subcategories CRUD
    subcategories: {
        create: async (subcategoryData) => {
            try {
                const { data } = await api.post('/api/issue-destination-subcategories/create/', subcategoryData);
                return data;
            } catch (error) {
                handleApiError(error, 'Create issue destination subcategory error:');
            }
        },
        
        getAll: async (params = {}) => {
            try {
                const { data } = await api.get('/api/issue-destination-subcategories/', { params });
                return data;
            } catch (error) {
                handleApiError(error, 'Get all issue destination subcategories error:');
            }
        },
        
        getById: async (id) => {
            try {
                const { data } = await api.get(`/api/issue-destination-subcategories/${id}/`);
                return data;
            } catch (error) {
                handleApiError(error, 'Get issue destination subcategory by id error:');
            }
        },
        
        update: async (id, subcategoryData) => {
            try {
                const { data } = await api.put(`/api/issue-destination-subcategories/update/${id}/`, subcategoryData);
                return data;
            } catch (error) {
                handleApiError(error, 'Update issue destination subcategory error:');
            }
        },
        
        delete: async (id) => {
            try {
                const { data } = await api.delete(`/api/issue-destination-subcategories/delete/${id}/`);
                return data;
            } catch (error) {
                handleApiError(error, 'Delete issue destination subcategory error:');
            }
        },
        
        getOptions: async (parentDestinationId = null) => {
            try {
                const params = parentDestinationId ? { parent_destination: parentDestinationId } : {};
                const { data } = await api.get('/api/issue-destination-subcategories/options/', { params });
                return data;
            } catch (error) {
                handleApiError(error, 'Get issue destination subcategory options error:');
            }
        },
        
    }
};